import React, { Component } from "react";
import styled from "styled-components";

const ErrorContainer = styled.div`
  padding: 2rem;
  margin: 2rem;
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  text-align: center;
`;

const ErrorHeading = styled.h2`
  color: #dc2626;
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  color: #7f1d1d;
  margin-bottom: 1rem;
`;

const ResetButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #b91c1c;
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
    });
    console.error("Error caught by boundary:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorHeading>Something went wrong</ErrorHeading>
          <ErrorMessage>
            {this.state.error?.message || "An unexpected error occurred"}
          </ErrorMessage>
          <ResetButton onClick={this.handleReset}>Try Again</ResetButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
